<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-fields">
    <!-- <h3 class="text-primary mb-4 mr-3 font-30px">
              {{ $t("precarity") }}
            </h3> -->

    <div
      :class="[
        tabFiche.precarityControl.precarity.$anyDirty &&
        tabFiche.precarityControl.precarity.$invalid
          ? 'field-hasError'
          : ''
      ]"
      class="giga-input_field col-lg-6"
    >
      <label class="input-field_label">{{ $t("precarity") }}
        <span v-if="tabFiche.precarityControl.precarity.required" class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <select
          id="precarity"
          v-model="tabFiche.precarityControl.precarity.$model"
          :disabled="isVIEWER"
          class="small-input"
          @change="getPrecarityByPeriodAndDepartment(tabFiche)"
        >
          <option
            v-for="precarity of precarityCases"
            :key="precarity.value"
            :value="precarity.value"
          >
            {{ precarity.name }}
          </option>
        </select>
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.precarity.$anyDirty &&
              tabFiche.precarityControl.precarity.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.precarity.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <!-- bigPrecarity -->
    <!-- CHECKBOX -->
    <div
      v-if="tabFiche.precarityControl.precarity.$model === 'CASE_1'"
      class="giga-input_field checkbox-field_area col-lg-12"
    >
      <div class="input-field_area">
        <div class="giga-cutsom_checkbox">
          <input
            type="checkbox"
            name="bigPrecarity"
            id="bigPrecarity"
            v-model="tabFiche.precarityControl.bigPrecarity.$model"
            :disabled="isVIEWER"
          />
          <label for="checkboxName"></label>
        </div>

        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.bigPrecarity.$anyDirty &&
              tabFiche.precarityControl.bigPrecarity.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.bigPrecarity.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
      <label class="input-field_label">{{
        $t("Ménage en grande précarité")
      }}
        <span class="text-danger">*</span>

      </label>
    </div>

    <!-- coupleNumber -->
    <div
      :class="[
        tabFiche.precarityControl.coupleNumber.$anyDirty &&
        tabFiche.precarityControl.coupleNumber.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="
        tabFiche.precarityControl.precarity.$model !== 'CASE_1' &&
          tabFiche.precarityControl.precarity.$model !== 'NO'
      "
      class="giga-input_field col-lg-12"
    >
      <label class="input-field_label">{{
        $t("Nombre total de ménages")
      }}
        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area" style="width: 50%">
        <input
          type="number"
          :disabled="isVIEWER"
          id="coupleNumber"
          v-model="tabFiche.precarityControl.coupleNumber.$model"
          class="small-input"
        />
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.coupleNumber.$anyDirty &&
              tabFiche.precarityControl.coupleNumber.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.coupleNumber.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <!-- coupleNumberInSocialHousing -->

    <div
      :class="[
        tabFiche.precarityControl.coupleNumberInSocialHousing.$anyDirty &&
        tabFiche.precarityControl.coupleNumberInSocialHousing.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="tabFiche.precarityControl.precarity.$model === 'CASE_2_BIS'"
      class="giga-input_field col-lg-6"
    >
      <label class="input-field_label">{{
        $t("Nombre de logements conventionnés APL") }}
        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <input
          type="number"
          :disabled="isVIEWER"
          id="coupleNumberInSocialHousing"
          v-model="tabFiche.precarityControl.coupleNumberInSocialHousing.$model"
          class="small-input"
        />
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.coupleNumberInSocialHousing.$anyDirty &&
              tabFiche.precarityControl.coupleNumberInSocialHousing.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="
              !tabFiche.precarityControl.coupleNumberInSocialHousing.required
            "
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <!-- couplePercentagePrecarity -->
    <div
      :class="[
        tabFiche.precarityControl.couplePercentagePrecarity.$anyDirty &&
        tabFiche.precarityControl.couplePercentagePrecarity.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="tabFiche.precarityControl.precarity.$model === 'CASE_3'"
      class="giga-input_field col-lg-6"
    >
      <label class="input-field_label" for="couplePercentagePrecarity">{{
        $t("Pourcentage de ménages en situation de précarité")
      }}        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <input
          type="number"
          :disabled="isVIEWER"
          id="couplePercentagePrecarity"
          v-model="tabFiche.precarityControl.couplePercentagePrecarity.$model"
          class="small-input"
        />
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.couplePercentagePrecarity.$anyDirty &&
              tabFiche.precarityControl.couplePercentagePrecarity.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.couplePercentagePrecarity.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <!-- couplePercentageBigPrecarity -->
    <div
      :class="[
        tabFiche.precarityControl.couplePercentageBigPrecarity.$anyDirty &&
        tabFiche.precarityControl.couplePercentageBigPrecarity.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="tabFiche.precarityControl.precarity.$model === 'CASE_3'"
      class="giga-input_field col-lg-6"
    >
      <label class="input-field_label" for="couplePercentagePrecarity">{{
        $t("Pourcentage de ménages en situation de grande précarité")
      }}        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <input
          type="number"
          :disabled="isVIEWER"
          id="couplePercentageBigPrecarity"
          v-model="
            tabFiche.precarityControl.couplePercentageBigPrecarity.$model
          "
          class="small-input"
        />
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.couplePercentageBigPrecarity.$anyDirty &&
              tabFiche.precarityControl.couplePercentageBigPrecarity.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="
              !tabFiche.precarityControl.couplePercentageBigPrecarity.required
            "
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <!-- coupleNumberPrecarity -->
    <div
      :class="[
        tabFiche.precarityControl.coupleNumberPrecarity.$anyDirty &&
        tabFiche.precarityControl.coupleNumberPrecarity.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="
        tabFiche.precarityControl.precarity.$model === 'CASE_2_BIS' ||
          tabFiche.precarityControl.precarity.$model === 'CASE_4'
      "
      class="giga-input_field col-lg-6"
    >
      <label class="input-field_label" for="coupleNumberPrecarity">{{
        $t("Nombre de ménages en situation de précarité")
      }}        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <input
          type="number"
          :disabled="isVIEWER"
          id="coupleNumberPrecarity"
          v-model="tabFiche.precarityControl.coupleNumberPrecarity.$model"
          class="small-input"
        />
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.coupleNumberPrecarity.$anyDirty &&
              tabFiche.precarityControl.coupleNumberPrecarity.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.coupleNumberPrecarity.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>
    <!-- coupleNumberBigPrecarity -->
    <div
      :class="[
        tabFiche.precarityControl.coupleNumberBigPrecarity.$anyDirty &&
        tabFiche.precarityControl.coupleNumberBigPrecarity.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="
        tabFiche.precarityControl.precarity.$model === 'CASE_2_BIS' ||
          tabFiche.precarityControl.precarity.$model === 'CASE_4'
      "
      class="giga-input_field col-lg-6"
    >
      <label class="input-field_label" for="coupleNumberPrecarity">{{
        $t("Nombre de ménages en situation de grande précarité")
      }}        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <input
          type="number"
          :disabled="isVIEWER"
          id="coupleNumberBigPrecarity"
          v-model="tabFiche.precarityControl.coupleNumberBigPrecarity.$model"
          class="small-input"
        />
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.coupleNumberBigPrecarity.$anyDirty &&
              tabFiche.precarityControl.coupleNumberBigPrecarity.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.coupleNumberBigPrecarity.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <!-- periodId -->
    <div
      :class="[
        tabFiche.precarityControl.periodId.$anyDirty &&
        tabFiche.precarityControl.periodId.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="
        tabFiche.precarityControl.precarity.$model === 'CASE_2' ||
          tabFiche.precarityControl.precarity.$model === 'CASE_2_BIS'
      "
      class="giga-input_field col-lg-6"
    >
      <label class="input-field_label" for="periodId">{{
        $t("Période")
      }}        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <select
          id="periodId"
          v-model="tabFiche.precarityControl.periodId.$model"
          disabled
          class="small-input"
        >
          <option v-for="period of periods" :key="period.id" :value="period.id">
            {{ period.name }}
          </option>
        </select>
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.periodId.$anyDirty &&
              tabFiche.precarityControl.periodId.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.periodId.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>
    <!-- department -->
    <div
      :class="[
        tabFiche.precarityControl.department.$anyDirty &&
        tabFiche.precarityControl.department.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="
        tabFiche.precarityControl.precarity.$model === 'CASE_2' ||
          tabFiche.precarityControl.precarity.$model === 'CASE_2_BIS'
      "
      class="giga-input_field col-lg-12"
    >
      <label class="input-field_label" for="periodId">{{
        $t("Département")
      }}        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <select
          id="department"
          v-model="tabFiche.precarityControl.department.$model"
          disabled
          class="small-input"
        >
          <option
            v-for="department of departments"
            :key="department.code"
            :value="department.code"
          >
            {{ department.name + " (" + department.code + ")" }}
          </option>
        </select>
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.department.$anyDirty &&
              tabFiche.precarityControl.department.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.department.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <!-- couplePercentagePrecarityByDepartment -->
    <div
      :class="[
        tabFiche.precarityControl.department.$anyDirty &&
        tabFiche.precarityControl.department.$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="
        tabFiche.precarityControl.precarity.$model === 'CASE_2' ||
          tabFiche.precarityControl.precarity.$model === 'CASE_2_BIS'
      "
      class="giga-input_field col-lg-6"
    >
      <label
        class="input-field_label"
        for="couplePercentagePrecarityByDepartment"
        >{{
          $t("Pourcentage de ménages en situation de précarité par département")
        }}        <span class="text-danger">*</span>
      </label
      >
      <div class="input-field_area">
        <input
          type="number"
          :disabled="isVIEWER"
          id="couplePercentagePrecarityByDepartment"
          v-model="
            tabFiche.precarityControl.couplePercentagePrecarityByDepartment
              .$model
          "
          class="small-input"
        />
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.department.$anyDirty &&
              tabFiche.precarityControl.department.$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="!tabFiche.precarityControl.department.required"
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <!-- couplePercentageBigPrecarityByDepartment -->
    <div
      :class="[
        tabFiche.precarityControl.couplePercentageBigPrecarityByDepartment
          .$anyDirty &&
        tabFiche.precarityControl.couplePercentageBigPrecarityByDepartment
          .$invalid
          ? 'field-hasError'
          : ''
      ]"
      v-if="
        tabFiche.precarityControl.precarity.$model === 'CASE_2' ||
          tabFiche.precarityControl.precarity.$model === 'CASE_2_BIS'
      "
      class="giga-input_field col-lg-6"
    >
      <label
        class="input-field_label"
        for="couplePercentagePrecarityByDepartment"
        >{{
          $t(
            "Pourcentage de ménages en situation de grande précarité par département"
          )
        }}<span class="text-danger">*</span>
      </label
      >
      <div class="input-field_area">
        <input
          type="number"
          :disabled="isVIEWER"
          id="couplePercentageBigPrecarityByDepartment"
          v-model="
            tabFiche.precarityControl.couplePercentageBigPrecarityByDepartment
              .$model
          "
          class="small-input"
        />
        <div
          class="validation-field-holder"
          v-if="
            tabFiche.precarityControl.couplePercentageBigPrecarityByDepartment
              .$anyDirty &&
              tabFiche.precarityControl.couplePercentageBigPrecarityByDepartment
                .$invalid
          "
        >
          <small
            class="form-text text-danger"
            v-if="
              !tabFiche.precarityControl
                .couplePercentageBigPrecarityByDepartment.required
            "
          >
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { constants } from "../../shared/constants";
export default {
  name: "Precatity",
  components: {},
  props: [
    "tabsFicheValidation",
    "tabFiche",
    "periods",
    "departments",
    "isVIEWER"
  ],
  data() {
    return {
      precarityCases: constants.PRECARITY_CASES
    };
  },
  methods: {
    getPrecarityByPeriodAndDepartment(tabFiche) {
      tabFiche.precarityControl.bigPrecarity.$model = null; // cas 1
      tabFiche.precarityControl.coupleNumberInSocialHousing.$model = null; // cas 2bis
      tabFiche.precarityControl.couplePercentagePrecarity.$model = null; // cas 3
      tabFiche.precarityControl.couplePercentageBigPrecarity.$model = null; // cas 3
      tabFiche.precarityControl.coupleNumberPrecarity.$model = null; // cas 2bis 4
      tabFiche.precarityControl.coupleNumberBigPrecarity.$model = null; // cas 2bis 4
      tabFiche.precarityControl.periodId.$model = null; // cas 2bis 2
      tabFiche.precarityControl.department.$model = null; // cas 2bis 2
      tabFiche.precarityControl.coupleNumber.$model = null; // cas 2bis 2
      tabFiche.precarityControl.couplePercentagePrecarityByDepartment.$model = null; // cas 2bis 2
      tabFiche.precarityControl.couplePercentageBigPrecarityByDepartment.$model = null; // cas 2bis 2
      this.tabsFicheValidation.$touch();
      this.$emit("fetchPrecarity", tabFiche);
    }
  }
};
</script>

<style scoped></style>
